import { getDocs, query } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { threadTempFilesCollectionRef } from '../features/threads/threadTempFiles';

export type ThreadTempFileRecord = {
  id: string; // attachmentId
  threadId: string;
  targetType?: 'post' | 'comment';
  targetId?: string;
  // legacy
  postId?: string;
  fileName: string;
  mimeType: string;
  size: number;
  storagePath: string;
  downloadURL: string;
  expiresAt: any;
  createdAt: any;
  createdBy: string;
  updatedAt: any;
  updatedBy: string;
  isDeleted?: boolean;
  deletedAt?: any;
  deletedBy?: string;
};

export const fetchThreadTempFiles = async (workspaceId: string): Promise<ThreadTempFileRecord[]> => {
  const col = threadTempFilesCollectionRef(workspaceId);
  const qRef = query(col);
  const snap = await getDocs(qRef);
  const out: ThreadTempFileRecord[] = [];
  snap.forEach((d) => {
    out.push({ ...(d.data() as any), id: d.id });
  });
  return out;
};

